var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "bg bg--grey4" }, [
    _c("div", { staticClass: "ug-container ug-container--variant_large" }, [
      _c("div", { staticClass: "router-tab" }, [
        _c(
          "div",
          { staticClass: "router-tab__common-wrapper" },
          [
            _vm._l(_vm.tabs, function(item, index) {
              return item.roles.includes(_vm.userRole)
                ? _c(
                    "router-link",
                    {
                      key: item.id,
                      staticClass: "router-tab__element",
                      attrs: {
                        to: { name: item.routs },
                        "exact-active-class": "router-tab__element--isactive"
                      }
                    },
                    [
                      _c("div", { staticClass: "router-tab__text" }, [
                        _vm._v(_vm._s(item.title))
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _c(
              "div",
              {
                staticClass:
                  "router-tab__element router-tab__element--pointer u-display u-display--block u-display--hidden-lg",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.postLogoutCabinetAPI($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "router-tab__text" }, [
                  _vm._v("Logout")
                ])
              ]
            )
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass:
              "router-tab__action-wrapper u-display u-display--hidden u-display--block-lg"
          },
          [
            _c(
              "div",
              {
                staticClass: "router-tab__element router-tab__element--pointer",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.postLogoutCabinetAPI($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "router-tab__text" }, [
                  _vm._v("Logout")
                ])
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b82f99ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b82f99ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modules/RouterModule.vue
// module id = 925
// module chunks = 0